import { useEffect, useState } from "react";

const useDisplayWidth = () => {
  const [displayWidth, setDisplayWidth] = useState(window.innerWidth);

    const updateDisplayWidth = () => {
        setDisplayWidth(window.innerWidth);
    };


    useEffect(() => {
        const handleResize = () => {
            updateDisplayWidth();
        };
        
        // Add an event listener to update the display width when the window is resized.
        window.addEventListener('resize', handleResize);

        // Call it initially to set the display width correctly when the component mounts.
        updateDisplayWidth();
    }, [])

    return displayWidth;
}

export default useDisplayWidth;
